import { ITEMS_TYPES } from "redux/reducers/integrations/itemsTypes";
import { api_get, api_post } from "services/api";
import { startRequest, stopRequest } from "../search/searchActions";

const {
    GET_ITEMS,
    NEW_ITEM,
    CLEAN_ITEM,
    REQUEST_ITEM,
    REQUEST_ITEM_STATIONS,
    GET_STATIONS,
    EDIT_PRICE,
    OPEN_MODAL_TO_UPDATE,
    CLOSE_EDIT,
    CLOSE_MODAL_ITEM,
    SET_SNACKBAR,
    RESET_SNACKBAR,
    SAVE_ITEMS_TO_UPDATE,
    REMOVE_ITEMS_TO_UPDATE,
    CLEAR_ITEMS_UPDATE,
    SET_CONFIG_FILTERED_ITEMS,
    SET_CONFIG_PAGE_ITEMS,
    SET_CONFIG_PAGE_ITEMS_COUNT,
    SET_CONFIG_SORTED_ITEMS,
    SET_CONFIG_PAGE_ITEM_STATIONS,
    SET_CONFIG_PAGE_ITEM_STATIONS_COUNT,
    SET_CONFIG_FILTERED_ITEM_STATIONS,
    SET_CONFIG_SORTED_ITEM_STATIONS,
    SAVE_ORIGINAL_ITEM_TO_UPDATE,
} = ITEMS_TYPES

const url = `${process.env.REACT_APP_URL_INTEGRATIONS}/items`;
const urlItemsRequest = `${process.env.REACT_APP_URL_INTEGRATIONS}/items_requests`;
const qid = `KZDut9V3GRvS9KeD`;


export const getItems = (search) => {
    const getItemsUrl = `${url}?qid=${qid}&term=${search}`
    return async (dispatch) => {
        dispatch(startRequest())
        await api_get(getItemsUrl).then(resp => {
            dispatch({
                type: GET_ITEMS,
                payload: {resp:resp, search: search}
            })
            dispatch(stopRequest())
        }).catch(err => {
            dispatch(setItemSnackbar(err))
            dispatch(stopRequest())
        })
    }
}

export const getStations = (itemNumber) => {
    const getItemsUrl = `${url}?qid=${qid}&itemNumber=${itemNumber}`;
    return async (dispatch) => {
        dispatch({ type: REQUEST_ITEM_STATIONS })
        await api_get(getItemsUrl).then(resp => {
            dispatch({
                type: GET_STATIONS,
                payload: resp
            })
        }).catch(err => {
            dispatch(setItemSnackbar(err))
            dispatch(closeModal())
        })
    }
}

export const getStationsUpdate = (itemNumber) => {
    const getItemsUrl = `${url}?qid=${qid}&itemNumber=${itemNumber}`;
    return async (dispatch) => {
        dispatch({ type: REQUEST_ITEM})
        await api_get(getItemsUrl).then(resp => {
            dispatch({
                type: GET_STATIONS,
                payload: resp
            })
        }).catch(err => {
            dispatch(setItemSnackbar(err))
            dispatch(closeModal())
        })
    }
}

export const itemsRequests = (form) => {
    const getItemsUrl = `${urlItemsRequest}?qid=${qid}`;
    return async (dispatch) => {
        dispatch({ type: REQUEST_ITEM_STATIONS })
        await api_post(getItemsUrl, form).then(resp => {
            dispatch({
                type: CLEAR_ITEMS_UPDATE,
            })
            dispatch(closeModal())
            dispatch(setItemSnackbar(`Folio: ${resp.itemsRequestFolio}`, 'success'))
            dispatch({ type: CLEAR_ITEMS_UPDATE})
        }).catch(err => {
            dispatch(setItemSnackbar(err))
            dispatch(closeModal())
        })
    }
}

export const editPrice = (station = null) => {
    return {
        type: EDIT_PRICE,
        payload: station
    }
}
export const openFormToUpdate = () => {
    return {
        type: OPEN_MODAL_TO_UPDATE,
    }
}

export const closeEdit = () => {
    return {
        type: CLOSE_EDIT,
    }
}

export const createNewItem = () => {
    return {
        type: NEW_ITEM,
    }
}

export const saveItemsToUpdate = (items) => {
    return {
        type: SAVE_ITEMS_TO_UPDATE,
        payload: items
    }
}

export const removeItemToUpdate = (index) => {
    return {
        type: REMOVE_ITEMS_TO_UPDATE,
        payload: index
    }
}

export const saveOriginalItemToUpdate = (item) => {
    return {
        type: SAVE_ORIGINAL_ITEM_TO_UPDATE,
        payload: item
    }
}

export const cleanItem = () => {
    return {
        type: CLEAN_ITEM,
    }
}

export const closeModal = () => {
    return {
        type: CLOSE_MODAL_ITEM
    }
}

export const setItemSnackbar = (message, color = 'danger') => {
    const newPayload = {
        message: message, color: color
    }
    return {
        type: SET_SNACKBAR,
        payload: newPayload
    }
}

export const resetItemSnackbar = () => {
    return {
        type: RESET_SNACKBAR,
    }
}
//config columns Items
export const configPageItems = (page) => {
    return { type: SET_CONFIG_PAGE_ITEMS, payload: page }
}

export const configPageItemsSize = (page) => {
    return {
        type: SET_CONFIG_PAGE_ITEMS_COUNT,
        payload: page
    }
}

export const configFilterItems = (filter) => {
    return { type: SET_CONFIG_FILTERED_ITEMS, payload: filter }
}

export const configSortedItems = (sorted) => {
    return { type: SET_CONFIG_SORTED_ITEMS, payload: sorted }
}
//Config column Stations
export const configPageItemStations = (page) => {
    return { type: SET_CONFIG_PAGE_ITEM_STATIONS, payload: page }
}

export const configPageItemStationsSize = (page) => {
    return {
        type: SET_CONFIG_PAGE_ITEM_STATIONS_COUNT,
        payload: page
    }
}

export const configFilterItemStations = (filter) => {
    return { type: SET_CONFIG_FILTERED_ITEM_STATIONS, payload: filter }
}

export const configSortedItemStations = (sorted) => {
    return { type: SET_CONFIG_SORTED_ITEM_STATIONS, payload: sorted }
}